export const otp = {
    result: 'success'
}